import { Icon } from '@acme/assets';
import { Spinner } from 'flowbite-react';

type DownloadButtonProps = {
  docId: string | undefined;
  downloadingId: string | null;
  onDownload: (e: React.MouseEvent) => void;
};

export const DownloadButton = ({
  docId,
  downloadingId,
  onDownload,
}: DownloadButtonProps) => (
  <button
    type="button"
    className="p-1 rounded hover:bg-gray-200 text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
    onClick={onDownload}
    disabled={docId != null && downloadingId === docId}
    title={downloadingId === docId ? 'Скачивание...' : 'Скачать'}
  >
    {downloadingId === docId ? (
      <Spinner size="sm" />
    ) : (
      <Icon name="download-outline" size={16} />
    )}
  </button>
);
